export default __webpack_public_path__ + "b889412ad4a166615b6644d4606b7593.png";